<app-top>
  <h1>Räkna på juverhälsa</h1>
  <h2>Se hur mycket du kan tjäna</h2>
</app-top>

<form class="form" [formGroup]="form" (submit)="onSubmitForm()">
  <div class="box">
    <div class="field">
      <label for="inp1" class="form-label">Antal kor</label>
      <div class="input-group">
        <input type="number" class="form-control" id="inp1" formControlName="cows" />
        <span class="input-group-text">st</span>
      </div>
      <div class="field-error" *ngIf="cows?.touched && cows?.invalid && !cows?.errors?.['required']">Ange antal kor.</div>
    </div>

    <div class="field">
      <label for="inp2" class="form-label">Mjölkproduktion per ko</label>
      <div class="input-group">
        <input type="number" class="form-control" id="inp2" formControlName="production" />
        <span class="input-group-text">kg/år</span>
      </div>
      <div class="field-error" *ngIf="production?.touched && production?.invalid && !production?.errors?.['required']">
        Ange mjölkproduktion per ko med en siffra mellan <span class="nowrap">1 000 och 20 000</span>.
      </div>
    </div>

    <div class="field">
      <label for="inp3" class="form-label">Nuvarande celltal</label>
      <div class="input-group">
        <input type="number" class="form-control" id="inp3" formControlName="cells" />
        <span class="input-group-text">tusen</span>
      </div>
      <div class="field-error" *ngIf="cells?.touched && cells?.invalid && !cells?.errors?.['required']">
        Ange nuvarande celltal med en siffra mellan <span class="nowrap">151 och 999</span>.
      </div>
    </div>

    <div class="field">
      <label for="inp4" class="form-label">Mjölkpris</label>
      <div class="input-group">
        <input type="number" class="form-control" id="inp4" formControlName="price" />
        <span class="input-group-text">kr/kg</span>
      </div>
      <div class="field-error" *ngIf="price?.touched && price?.invalid && !price?.errors?.['required']">
        Ange mjölkpris i kronor per kilo med en siffra <span class="nowrap">mellan 2 och 0</span>.
      </div>
    </div>
  </div>
  <div class="buttons">
    <button type="submit" appButton class="primary-btn" [class.disabled]="!form.valid">Räkna</button>
  </div>
</form>
